<template>
  <component
    :is="componentType"
    v-if="isDialerVisible"
    :actions-type="actionsType"
    component="page"
    @toggle-keypad="navigation = 'keypad'"
    @toggle-members-page="navigation = 'members'"
    @toggle-invite-page="navigation = 'invite'"
    @toggle-transfer-page="navigation = 'transfer'"
    @go-back="navigation = 'main'"
  />
</template>

<script lang="ts">
import { Component } from 'vue';
import { defineComponent } from 'vue-demi';

import AppDialerMainPageContainer from '../../containers/pages/AppDialerMainPageContainer.vue';
import AppDialerKeypadContainer from '../../containers/common/AppDialerKeypadContainer.vue';
import AppDialerCallMembersContainer from '../../containers/common/AppDialerCallMembersContainer.vue';
import AppDialerActionsPageContainer from '../../containers/pages/AppDialerActionsPageContainer.vue';
import {
  useDialerStore,
  useDialerActions,
  useDialerReconnectConference,
} from '../../composables';

type NavigationState = 'main' | 'keypad' | 'members' | 'invite' | 'transfer';

export default defineComponent({
  name: 'AppDialerPage',
  setup() {
    const { isDialerVisible } = useDialerStore();
    const { subscribeRingtone, subscribeToIsVisible } = useDialerActions();
    const { subscribeToReconnectFeature } = useDialerReconnectConference();

    subscribeRingtone();
    subscribeToReconnectFeature();
    subscribeToIsVisible();
    return { isDialerVisible };
  },
  data() {
    return {
      navigation: 'main' as NavigationState,
    };
  },
  computed: {
    componentType(): Component {
      switch (this.navigation) {
        case 'keypad':
          return AppDialerKeypadContainer;
        case 'members':
          return AppDialerCallMembersContainer;
        /* An additional prop with the same value manages the content of "Actions Page" */
        case 'invite':
        case 'transfer':
          return AppDialerActionsPageContainer;
        case 'main':
        default:
          return AppDialerMainPageContainer;
      }
    },

    actionsType(): string {
      return ['invite', 'transfer'].includes(this.navigation)
        ? this.navigation
        : '';
    },
  },
  watch: {
    isDialerVisible(isVisible: boolean) {
      if (isVisible) {
        this.navigation = 'main';
      }
    },
  },
});
</script>
